module.exports = __webpack_public_path__ + "static/media/Jeida4.a1c81959.jpg";